<div class="flex flex-col gap-4 bg-white text-slate-900 dark:bg-slate-900 dark:text-slate-100 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 p-5">
  <div class="flex items-center justify-between">
    <h2 mat-dialog-title class="text-lg font-semibold tracking-tight">Crear contacto</h2>
  </div>

  <div mat-dialog-content class="max-h-[70vh] overflow-auto pr-1">
    <app-form [formGroup]="saveForm">
      <!-- Datos obligatorios -->
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <app-label for="nombre">
            Nombre
          </app-label>
          <app-input-field id="nombre" type="text" formControlName="nombre" placeholder="Ingrese el nombre" />
        </div>

        <div>
          <app-label for="apellido">
            Apellido
          </app-label>
          <app-input-field id="apellido" type="text" formControlName="apellido" placeholder="Ingrese el apellido" />
        </div>

        <div>
          <app-label for="celular">
            Celular
          </app-label>
          <app-input-field id="celular" type="text" formControlName="celular" placeholder="Ingrese el celular" />
        </div>

        <div>
          <app-label for="param_establecimiento_tipo_contacto_id">
            Tipo de contacto
          </app-label>
          <app-select id="param_establecimiento_tipo_contacto_id" formControlName="param_establecimiento_tipo_contacto_id" placeholder="Seleccione" [options]="tiposContactosAdministrativosOptions" />
        </div>
      </div>

      <!-- Datos opcionales -->
      <div class="mt-5 mb-3 border-t border-gray-200 pt-3 dark:border-gray-700">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Datos adicionales</h3>
      </div>

      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <div>
          <app-label for="email">
            Email
          </app-label>
          <app-input-field id="email" type="email" formControlName="email" placeholder="Ingrese el email" />
        </div>

        <div>
          <app-label for="cli_establecimiento_id">
            Establecimiento
          </app-label>
          <app-select id="cli_establecimiento_id" formControlName="cli_establecimiento_id" placeholder="Ninguno (contacto administrativo)" [options]="establecimientosOptions" />
        </div>

        <div>
          <app-label for="activo">
            Estado
          </app-label>
          <div class="flex items-center gap-3 mt-2">
            <app-switch id="activo" formControlName="activo"></app-switch>
            <span class="text-sm text-gray-700 dark:text-gray-300">
              {{ saveForm.get('activo')?.value ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
        </div>
      </div>
    </app-form>
  </div>

  <div mat-dialog-actions class="flex justify-end border-t border-slate-200 dark:border-slate-800 pt-4 mt-1">
    <app-creation-buttons *hasPermission="'clientes:create'"
      [valid]="saveForm.valid"
      [process]="loading"
      (onCreateClick)="create()"
      (onCancelClick)="cancel()"
    />
  </div>
</div>
